import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7e00e2cd")

_pushScopeId("data-v-7e00e2cd")
const _hoisted_1 = { class: "more_member_mask" }
const _hoisted_2 = { class: "more_member_container" }
const _hoisted_3 = { class: "mm_head flex_space_center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "更多会员信息", -1)
const _hoisted_5 = { class: "mm_content" }
const _hoisted_6 = { class: "member_name" }
const _hoisted_7 = { class: "member_date" }
const _hoisted_8 = {
  key: 0,
  class: "member_date"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("i", {
          class: "mm_close",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeMoreMember && _ctx.closeMoreMember(...args)))
        })
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("ul", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.viewModel.formatDateVipInfo, (item, idx) => {
            return (_openBlock(), _createBlock("li", {
              key: idx,
              class: "flex_start_center"
            }, [
              _createVNode("img", {
                src: item.page_detail.img_url,
                alt: ""
              }, null, 8, ["src"]),
              _createVNode("div", null, [
                _createVNode("div", _hoisted_6, _toDisplayString(item.page_detail.name), 1),
                _createVNode("div", _hoisted_7, _toDisplayString(item.expired_at), 1),
                (item.vip_type === 'fastpic_normal' || item.vip_type === 'fastpic_diamond')
                  ? (_openBlock(), _createBlock("div", _hoisted_8, " (抠图下载：会员赠送" + _toDisplayString(item.fastpic_cutout_free) + "次，永久有效" + _toDisplayString(item.fastpic_cutout_independent) + "次） ", 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
})